<template>
    <div class="storeItem">
        <div class="storeNameView">
            <div class="storeName">{{ item.storeName }}</div>
            <div class="storeProfit" @click="showTips">
                ¥{{ item.storeAgentMoney }}
                <icon name="question" />
            </div>
        </div>
        <div class="storeItemRow" v-if="showDeviceCount">
            <span class="storeItemRowLabel">设备：</span>
            <span class="storeItemRowValue"
                >底座{{ item.deviceCount }}台
            </span>
        </div>
        <div class="storeItemRow" v-if="showOrderCount">
            <span class="storeItemRowLabel">订单量：</span>
            <span class="storeItemRowValue">{{ item.orderCount }}单</span>
        </div>
        <div class="storeItemRow">
            <span class="storeItemRowLabel">地址：</span>
            <span class="storeItemRowValue">{{ item.address }}</span>
        </div>
    </div>
</template>

<script>
/*
 * @AUTHOR: Mr.Huang
 * @DATA: 2020/6/4 10:39 上午
 * 网点列表子项
 */
import { Icon } from "vant";
export default {
    name: "storeItem",
    components: { Icon },
    props: {
        item: {
            type: Object,
            default: {}
        },
        showOrderCount: {
            type: Boolean,
            default: false
        },
        showDeviceCount: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        showTips() {
            this.toast({
                text: "商家获取的网点累计收益"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.storeItem {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    min-height: 25.6vw;
    margin-top: 2.67vw;
    padding: 1vw 4vw;
    font-size: 3.2vw;
    background-color: #ffffff;
    border-radius: 2.67vw;
    box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    .storeNameView {
        display: flex;
        justify-content: space-between;
        .storeName {
            color: #333333;
        }
        .storeProfit {
            display: flex;
            align-items: center;
            color: #43a2fe;
        }
    }
    .storeItemRow {
        .storeItemRowLabel {
            color: #a2a2a2;
        }
        .storeItemRowValue {
            color: #333333;
        }
        img {
            vertical-align: middle;
            width: 3.2vw;
            height: 3.2vw;
            margin-left: 0.5vw;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/storeItem.vue